import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table table-striped table-row-gray-100 align-middle gs-0 gy-3 text-center h4"
}
const _hoisted_2 = { class: "fw-bolder" }
const _hoisted_3 = {
  class: "min-w-140px",
  colspan: "2"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "18-29", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "30-49", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "> 50", -1)
const _hoisted_7 = {
  colspan: "2",
  class: "fw-bolder"
}
const _hoisted_8 = {
  colspan: "2",
  class: "fw-bolder"
}
const _hoisted_9 = {
  rowspan: "3",
  class: "fw-bolder"
}
const _hoisted_10 = { class: "fw-bolder" }
const _hoisted_11 = { class: "fw-bolder" }
const _hoisted_12 = { class: "fw-bolder" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  rowspan: "3",
  class: "fw-bolder"
}
const _hoisted_20 = { class: "fw-bolder" }
const _hoisted_21 = ["title"]
const _hoisted_22 = ["title"]
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "fw-bolder" }
const _hoisted_25 = ["title"]
const _hoisted_26 = ["title"]
const _hoisted_27 = ["title"]
const _hoisted_28 = { class: "fw-bolder svg-icon-2x" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.tableData)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_2, [
            _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.tableData.year), 1),
            _hoisted_4,
            _hoisted_5,
            _hoisted_6
          ])
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_7, " % " + _toDisplayString(_ctx.translate("WOMEN_BY_AGO_RANGE")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.tableData.val_4), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.tableData.val_5), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.tableData.val_6), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_8, " % " + _toDisplayString(_ctx.translate("MEN_BY_AGO_RANGE")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.tableData.val_7), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.tableData.val_8), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.tableData.val_9), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.translate("NEW_EMPLOYEES_LABEL")), 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.tableData.d_6_2), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.tableData.d_6_3), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.tableData.d_6_4), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.tableData.u_6_2), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.tableData.u_6_3), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.tableData.u_6_4), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")) + " VS " + _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")), 1),
            _createElementVNode("td", null, [
              (_ctx.tableData.F1_DONNE_ENTRATE && _ctx.tableData.F1_UOMINI_ENTRATI)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.tableData.F1_DONNE_ENTRATE) + "% vs " + _toDisplayString(_ctx.tableData.F1_UOMINI_ENTRATI) + "%", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, "--"))
            ]),
            _createElementVNode("td", null, [
              (_ctx.tableData.F2_DONNE_ENTRATE && _ctx.tableData.F2_UOMINI_ENTRATI)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.tableData.F2_DONNE_ENTRATE) + "% vs " + _toDisplayString(_ctx.tableData.F2_UOMINI_ENTRATI) + "%", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, "--"))
            ]),
            _createElementVNode("td", null, [
              (_ctx.tableData.F3_DONNE_ENTRATE && _ctx.tableData.F3_UOMINI_ENTRATI)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.tableData.F3_DONNE_ENTRATE) + "% vs " + _toDisplayString(_ctx.tableData.F3_UOMINI_ENTRATI) + "%", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_18, "--"))
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.translate("EXITED_EMPLOYEES")), 1),
            _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")), 1),
            _createElementVNode("td", null, [
              (_ctx.tableData.USCENTI_F1_DONNE == 'N/A')
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fas fa-exclamation-circle ms-1 fs-2 me-2",
                    "data-bs-toggle": "tooltip",
                    title: _ctx.translate('INCONSISTENT_DATA_TOOLTIP_LABEL')
                  }, null, 8, _hoisted_21))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.tableData.USCENTI_F1_DONNE), 1)
            ]),
            _createElementVNode("td", null, [
              (_ctx.tableData.USCENTI_F2_DONNE == 'N/A')
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fas fa-exclamation-circle ms-1 fs-2 me-2",
                    "data-bs-toggle": "tooltip",
                    title: _ctx.translate('INCONSISTENT_DATA_TOOLTIP_LABEL')
                  }, null, 8, _hoisted_22))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.tableData.USCENTI_F2_DONNE), 1)
            ]),
            _createElementVNode("td", null, [
              (_ctx.tableData.USCENTI_F3_DONNE == 'N/A')
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fas fa-exclamation-circle ms-1 fs-2 me-2",
                    "data-bs-toggle": "tooltip",
                    title: _ctx.translate('INCONSISTENT_DATA_TOOLTIP_LABEL')
                  }, null, 8, _hoisted_23))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.tableData.USCENTI_F3_DONNE), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")), 1),
            _createElementVNode("td", null, [
              (_ctx.tableData.USCENTI_F1_UOMINI == 'N/A')
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fas fa-exclamation-circle ms-1 fs-2 me-2",
                    "data-bs-toggle": "tooltip",
                    title: _ctx.translate('INCONSISTENT_DATA_TOOLTIP_LABEL')
                  }, null, 8, _hoisted_25))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.tableData.USCENTI_F1_UOMINI), 1)
            ]),
            _createElementVNode("td", null, [
              (_ctx.tableData.USCENTI_F2_UOMINI == 'N/A')
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fas fa-exclamation-circle ms-1 fs-2 me-2",
                    "data-bs-toggle": "tooltip",
                    title: _ctx.translate('INCONSISTENT_DATA_TOOLTIP_LABEL')
                  }, null, 8, _hoisted_26))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.tableData.USCENTI_F2_UOMINI), 1)
            ]),
            _createElementVNode("td", null, [
              (_ctx.tableData.USCENTI_F3_UOMINI == 'N/A')
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fas fa-exclamation-circle ms-1 fs-2 me-2",
                    "data-bs-toggle": "tooltip",
                    title: _ctx.translate('INCONSISTENT_DATA_TOOLTIP_LABEL')
                  }, null, 8, _hoisted_27))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.tableData.USCENTI_F3_UOMINI), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")) + " VS " + _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")), 1),
            _createElementVNode("td", null, [
              (_ctx.tableData.F1_DONNE_USCITE && _ctx.tableData.F1_UOMINI_USCITI)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.tableData.F1_DONNE_USCITE) + "% vs " + _toDisplayString(_ctx.tableData.F1_UOMINI_USCITI) + "%", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_30, "--"))
            ]),
            _createElementVNode("td", null, [
              (_ctx.tableData.F2_DONNE_USCITE && _ctx.tableData.F2_UOMINI_USCITI)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.tableData.F2_DONNE_USCITE) + "% vs " + _toDisplayString(_ctx.tableData.F2_UOMINI_USCITI) + "%", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_32, "--"))
            ]),
            _createElementVNode("td", null, [
              (_ctx.tableData.F3_DONNE_USCITE && _ctx.tableData.F3_UOMINI_USCITI)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.tableData.F3_DONNE_USCITE) + "% vs " + _toDisplayString(_ctx.tableData.F3_UOMINI_USCITI) + "%", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_34, "--"))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}